import type { AddressMode } from '@pages/payments/utils/addressUtils';
import type { FieldValues, Path } from 'react-hook-form';
import { useWatch } from 'react-hook-form';

import { AddressGroupInput } from './AddressGroupInput';
import { UnstructuredAddressInput } from './UnstructuredAddressInput';

type PaymentAddressInputProps<T extends FieldValues> = {
	prefix: Path<T>;
	translatePrefix: string;
	required?: boolean;
	disabled?: boolean;
	requiredIfSelection?: boolean;
	// ToDp: remove when BT-996-structured-addresses-in-ib-payments will be removed
	unstructuredLineLabelKey?: string;
};

export const PaymentAddressInput = <T extends FieldValues>({
	prefix,
	translatePrefix,
	required,
	disabled,
	requiredIfSelection,
	unstructuredLineLabelKey,
}: PaymentAddressInputProps<T>) => {
	const mode = useWatch({ name: `${prefix}.type` as Path<T> }) as AddressMode | undefined;

	if (mode === 'UNSTRUCTURED') {
		return (
			<UnstructuredAddressInput<T>
				prefix={prefix}
				translatePrefix={translatePrefix}
				disabled={disabled}
				lineLabelKey={unstructuredLineLabelKey}
				required={required}
				requiredIfSelection={requiredIfSelection}
			/>
		);
	}

	return (
		<AddressGroupInput<T>
			prefix={prefix}
			translatePrefix={translatePrefix}
			disabled={disabled}
			required={required}
			requiredIfSelection={requiredIfSelection}
		/>
	);
};
